import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialLogin = ({ onSocialLogin, isLoading }) => {
  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'bg-white border-border text-foreground hover:bg-muted'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Smartphone',
      color: 'bg-foreground text-background hover:bg-foreground/90'
    },
    {
      id: 'microsoft',
      name: 'Microsoft',
      icon: 'Square',
      color: 'bg-blue-600 text-white hover:bg-blue-700'
    }
  ];

  const handleSocialLogin = (provider) => {
    if (onSocialLogin) {
      onSocialLogin(provider);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="space-y-4">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-background text-muted-foreground">Or continue with</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3">
          {socialProviders?.map((provider) => (
            <Button
              key={provider?.id}
              variant="outline"
              size="lg"
              fullWidth
              onClick={() => handleSocialLogin(provider?.id)}
              disabled={isLoading}
              className={`${provider?.color} transition-standard`}
            >
              <div className="flex items-center justify-center space-x-3">
                <Icon name={provider?.icon} size={20} />
                <span>Continue with {provider?.name}</span>
              </div>
            </Button>
          ))}
        </div>

        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            By continuing, you agree to our{' '}
            <button className="text-primary hover:text-primary/80 underline transition-standard">
              Terms of Service
            </button>{' '}
            and{' '}
            <button className="text-primary hover:text-primary/80 underline transition-standard">
              Privacy Policy
            </button>
          </p>
        </div>
      </div>
      {/* Benefits of Social Login */}
      <div className="mt-6 bg-muted/50 rounded-lg p-4">
        <h4 className="font-medium text-foreground mb-2 text-center">Quick & Secure Registration</h4>
        <div className="space-y-2">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Zap" size={14} className="text-accent" />
            <span>Instant account creation</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Shield" size={14} className="text-success" />
            <span>Enhanced security with OAuth</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Key" size={14} className="text-secondary" />
            <span>No need to remember passwords</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialLogin;